export default "__VITE_ASSET__B7DVK4aM__"